
<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2 ">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">
    <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header">
      <h2 class="text-xl text-white font-semibold w-fit mb-0">Tarifas de llamadas internacionales</h2>
    </div>
    <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">
      <div class="flex mt-6 mb-6 inset-x-0 bottom-0">
        <div *ngIf="loading" class="w-full text-center">
          <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
        </div>

        <app-generic-list class="w-full flex-col" *ngIf="itemsList.length > 0 && !loading"
          filterKeyPrefix="calls-pricing"
          [items]="itemsList"
          (itemClick)="onItemClick($event)"
          [filterFields]="filterItems"
          [showFilters]="true"
          [isFiltersCollapsed]="true"
          [allowDownload]="true"
          (pageChanged)="loadMore()"
          (filteredCount)="filteredCounts.itemsList = $event"
          [pageSize]="7">

          <ng-template #tableHeaderTemplate>
            <div class="flex items-center border-b py-2 font-semibold text-sm text-gray-700">
              <div class="w-[300px] truncate text-gray-500 mr-4">Network</div>
              <div class="w-[200px] truncate text-gray-500 mr-4">Country code</div>
              <div class="w-[200px] truncate text-gray-500 mr-4">Amount</div>
              <div class="w-[120px] truncate text-gray-500 mr-4">Created at</div>
              <div class="w-[120px] truncate text-gray-500 mr-4">Updated at</div>
            </div>
          </ng-template>

          <ng-template #itemTemplate let-item>
            <div class="flex items-center border-b py-2 text-sm overflow-x-auto">
              <div class="w-[300px] truncate overflow-hidden whitespace-nowrap font-bold mr-4" title="{{ item.network }}">{{ item.network }}</div>
              <div class="w-[200px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" title="{{ item.toCountryCode }}">{{ item.toCountryCode }}</div>
              <div class="w-[200px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" title="{{ item.amountPerMinuteEuro }}">{{ item.amountPerMinuteEuro }}</div>
              <div class="w-[120px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4">{{ item.createdAt | date:'dd/MM/yyyy' }}</div>
              <div class="w-[120px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4">{{ item.updatedAt | date:'dd/MM/yyyy' }}</div>
            </div>
          </ng-template>

          <div *ngIf="filteredCounts.itemsList == 0 && !loading" class="w-full content-center h-[200px]">
            <div class="!font-medium text-center">
              <mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">people</mat-icon><br />
              No se encontraron tarifas
            </div>
          </div>
        </app-generic-list>
      </div>
    </div>
  </div>
  <!--<div>
    <button mat-button color="primary" (click)="onNewItem()">{{ 'COMPONENTS.PROFILE.CREATE' | translate }}</button>
  </div>-->
  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>
